import React, { Component } from 'react'
import { View, StyleSheet, ActivityIndicator } from 'react-native'

export default class Loading extends Component {
  render() {
    return (
      <View style={styles.wrapper}>
        <ActivityIndicator size="large" />
      </View>
    )
  }
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
})
